/**
 * Central list of GTM tracked events. Add new events here so all devs get autocomplete.
 * Use GTM_TRACKED_EVENTS.* or GtmEventName in createGTMTracking().
 */

export const GTM_TRACKED_EVENTS = {
  // Job
  JOB_VIEW_DETAILS: 'job_view_details',
  OPEN_UPLOAD_MODAL: 'open_upload_modal',
  UPLOAD_MODAL_ACTION: 'upload_modal_action',
  ARCHIVE_JOB: 'archive_job',
  DELETE_JOB: 'delete_job',
  DOWNLOAD_JOB_DESCRIPTION: 'download_job_description',
  SEARCH_JOBS: 'search_jobs',
  FILTER_JOBS: 'filter_jobs',

  // Interview
  SEND_INTERVIEW: 'send_interview',
  CONFIGURE_EXAM: 'configure_exam',
  PREVIEW_INTERVIEW: 'preview_interview',
  EXTEND_INTERVIEW: 'extend_interview',
  VIEW_AI_TEST_OVERVIEW: 'view_ai_test_overview',
  START_AI_TEST: 'start_ai_test',

  // Candidate
  APPROVE_CANDIDATE: 'approve_candidate',
  DECLINE_CANDIDATE: 'decline_candidate',
  HIRE_CANDIDATE: 'hire_candidate',
  SHORTLIST_CANDIDATE: 'shortlist_candidate',
  DELETE_CANDIDATE: 'delete_candidate',
  DOWNLOAD_CV: 'download_cv',
  DOWNLOAD_ASSESSMENT: 'download_assessment',
  NAVIGATE_CANDIDATE_STATUS: 'navigate_candidate_status',
  SWITCH_CANDIDATE_VIEW: 'switch_candidate_view',
  SEARCH_CANDIDATES: 'search_candidates',
  FILTER_CANDIDATES: 'filter_candidates',
  OPEN_META_CV: 'open_meta_cv',
  CLOSE_META_CV: 'close_meta_cv',
  NAVIGATE_META_CV: 'navigate_meta_cv',
  OPEN_INTERVIEW_LINK_META_CV: 'open_interview_link_meta_cv',
  UPDATE_EMAIL_META_CV: 'update_email_meta_cv',
  META_CV_VISIBLE: 'meta_cv_visible',
  META_CV_SECTION_VIEWED: 'meta_cv_section_viewed',
  META_CV_VIDEO_ENGAGED: 'meta_cv_video_engaged',

  // Landing (order: landing page section flow Hero → Footer)
  SECTION_VIEWED: 'section_viewed',
  REQUEST_DEMO: 'request_demo',
  NAVIGATE_SECTION: 'navigate_section',
  CAROUSEL_NAVIGATE: 'carousel_navigate',
  SWITCH_INTERVIEW_TAB: 'switch_interview_tab',
  PLAN_SELECTED: 'plan_selected',
  SWITCH_CURRENCY: 'switch_currency',
  SWITCH_PLAN: 'switch_plan',
  SUBMIT_LEAD: 'submit_lead',
  SUBSCRIBE_NEWSLETTER: 'subscribe_newsletter',
  SOCIAL_CLICK: 'social_click',

  // Auth
  LOGIN: 'login',
  LOGOUT: 'logout',
  SIGNUP: 'signup',

  // Other
  PUBLIC_CV_UPLOAD: 'public_cv_upload',
  UPLOADED_CVS: 'uploaded_cvs',
  TOGGLE_VIEW: 'toggle_view',
  
  // Workflows
  JOB_OFFER_CREATION_WORKFLOW: 'job_offer_creation_workflow',
  COMPLETE_JOB_INFO_WORKFLOW: 'complete_job_info_workflow',
  
  // Upgrade
  UPGRADE_PLAN: 'upgrade_plan',
} as const;

/** Keys of GTM_TRACKED_EVENTS. Use createGTMTracking('SECTION_VIEWED', ...) — not a raw string. */
export type GtmEventKey = keyof typeof GTM_TRACKED_EVENTS;

/** Event name values (for data-gtm). Add new events in GTM_TRACKED_EVENTS. */
export type GtmEventName = (typeof GTM_TRACKED_EVENTS)[GtmEventKey];
